import { render, staticRenderFns } from "./myExam.vue?vue&type=template&id=4155488d&scoped=true&"
import script from "./myExam.vue?vue&type=script&lang=js&"
export * from "./myExam.vue?vue&type=script&lang=js&"
import style0 from "./myExam.vue?vue&type=style&index=0&id=4155488d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4155488d",
  null
  
)

export default component.exports